module.exports = __webpack_public_path__ + "static/img/comIcon1.bb543801.png";